(function () {

    'use strict';

    angular.module('iplusjs.filter.toTrusted', [])
        .filter('toTrusted', ToTrusted);

    ToTrusted.$inject = [
        '$sce'
    ];
    function ToTrusted($sce) {
        return function (value) {
            return $sce.trustAsHtml(value);
        };
    }
})();
